<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Auto attachment platform wise report {{this.$route.query.train_date}}
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :fixed-header="true"
        :items="positions"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
        }"
        :items-per-page="40"
        item-key="id"
        class="elevation-1"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :mobile-breakpoint="100"
        :sort-by="['pf']"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsonexport from "jsonexport/dist";
import { saveAs } from "file-saver";
import { mapState, mapGetter, mapActions } from "vuex";

export default {
  name: "auto_attach_pf_rep",
  data() {
    return {
      csvurl: null,
      errors: [],
      headers: [
        {
          text: "Platform",
          align: "left",
          sortable: true,
          value: "pf",
        },
        { text: "Total Arrival", value: "tot_arrival" },
        { text: "Auto Dectectd", value: "auto_arrival" },
        { text: "% auto detection", value: "per_auto_detect" },
        { text: "Total Deperture", value: "tot_deperture" },
        { text: "Auto attached", value: "auto_attach" },
        { text: "% auto attachment", value: "per_auto_attach" },
      ],
      position: {},
      positions: [],
      isLoading: false,
    };
  },
  created() {
    this.getPositions();
  },
  computed: {
    ...mapState(["curStartDate", "curEndDate"]),
  },
  methods: {
    ...mapActions(["updateCurStartDate", "updateCurEndDate"]),
    clear() {},
    getPositions() {
      var p = {
        start_date: moment(this.$route.query.train_date, ["DD/MM/YYYY"]).format("YYYY-MM-DD"),
      };
      console.log(p);
      //      console.log(this.curDeviceId)
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/train/tr/auto_attachment_pf_summary`,
          {
            params: p,
          }
        )
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          for (var i = 0; i < this.positions.length; i++) {
            this.positions[i].per_auto_detect = this.round(
              (this.positions[i].auto_arrival * 100) /
                this.positions[i].tot_arrival,
              2
            );
            this.positions[i].per_auto_attach = this.round(
              (this.positions[i].auto_attach * 100) /
                this.positions[i].tot_deperture,
              2
            );
          }
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },

    getFormattedTime(t) {
      if (t !== "--") {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment(lt);
        //  var localDate = moment(testDateUtc).local();
        return testDateUtc.format("HH:mm:ss");
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return "-" + moment.utc(Math.abs(t) * 1000).format("HH:mm:ss");
      } else {
        return moment.utc(Math.abs(t) * 1000).format("HH:mm:ss");
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY");
    },
    createCSV() {
      // let csvContent = "data:text/csv;charset=utf-8,";
      // var filename = this.curStartDate + '-' + this.curEndDate + '.csv'
      // var ctr = []
      // for(var i=0; i <this.positions.length; i++ ) {
      //   ctr.push({
      //     srl_no: this.positions[i]['srl_no'],
      //     stn_code: this.positions[i]['stn_code'],
      //     sch_arr:  this.positions[i]['sch_arr'],
      //     sch_dep:  this.positions[i]['sch_dep'],
      //     act_arr: this.positions[i]['act_arr'],
      //     act_dep: this.positions[i]['act_dep'],
      //     late_in: this.positions[i]['late_in'],
      //     late_out: this.positions[i]['late_out'],
      //     stop_time: this.positions[i]['stop_time'],
      //     stn_enter_speed: this.positions[i]['geofence_enter_speed'],
      //     loss_gain_on_run: this.positions[i]['loss_gain_on_run_formatted'],
      //     sec_distance: this.positions[i]['sectional_dist'],
      //     sec_avg_speed: this.positions[i]['avg_speed'],
      //     sec_max_speed: this.positions[i]['sec_max_speed']
      //   })
      // }
      // ctr[0]['late_in'] = '--'
      // ctr[0]['sch_arr'] = '--'
      // ctr[0]['act_arr'] = '--'
      // ctr[0]['stop_time'] = '--'
      // ctr[0]['stn_enter_speed'] = '--'
      // ctr[this.positions.length-1]['late_out'] = '--'
      // ctr[this.positions.length-1]['sch_dep'] = '--'
      // ctr[this.positions.length-1]['act_dep'] = '--'
      // ctr[this.positions.length-1]['stop_time'] = '--'
      //
      // jsonexport(ctr,function(err, csv){
      //    if(err) return console.log(err);
      //    //console.log(csv);
      //    var blob = new Blob([csv], {
      //     type: "data:text/csv;charset=utf-8,"
      //    });
      //    saveAs(blob, filename);
      //   });
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
  },
};
</script>
